import * as permissions from "./permissions";
import i18n from "@/common/lang.serivce";

const PermissionsService = {
  list() {
    return Object.keys(permissions);
  },
  getAll() {
    return this.list().map(permission => {
      return {
        value: permission,
        text: i18n.t("permissionsRole." + permission)
      };
    });
  },
  getString(permissions) {
    return permissions
      .map(permission => {
        return i18n.t("permissionsRole." + permission);
      })
      .join(", ");
  }
};

export default PermissionsService;
